/**
 * @generated SignedSource<<b041eea664496c5c4127210ee474c18f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountNav_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountNavContent_viewer" | "TradeAccountNavContent_viewer">;
  readonly " $fragmentType": "AccountNav_viewer";
};
export type AccountNav_viewer$key = {
  readonly " $data"?: AccountNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountNavContent_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeAccountNavContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "234796475be4851e2a6ae40d46958f57";

export default node;
